/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React from 'react';
import { Link } from 'react-router-dom';
import {
    object, string, func, shape, number, bool,
} from 'prop-types';
import { connect, useSelector } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import Cookies  from 'universal-cookie';
import { getBrand } from '../../../../state/ducks/App/ducks/Brand/Brand-Selectors';
import { getPresentationFamily, getFeatureFlags } from '../../../../state/ducks/App/ducks/Config/Config-Selectors';
import { actions as tagManagerActions } from '../../../../state/ducks/TagManager';

import { commonSelectors } from '../../../../state/ducks/Common';
import { cartStatusCompleteList } from '../../../helpers/common/helper';
import useIsKeeper from '../../../helpers/hooks/useIsKeeper';
import { getPageType } from '../../../../state/ducks/App/App-Selectors';

const styles = (theme) => ({
    cartEmpty: {
        color: '#969696',
    },
    cartFill: {
        color: '#b30200',
    },
    cartTextStyle: {
        display: 'block',
    },
    flowersCartIcon: {},
    flowerCartMobile: {
        padding: '0 !important',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        alignSelf: 'center',
        textAlign: 'center',
        fontWeight: 'bold',
        letterSpacing: '0.6px',
    },
    cartMobile: {
        // CSS Grid
        gridRow: '1',
        gridColumn: '5',
        fontSize: '10px',
        textTransform: 'capitalize',
        letterSpacing: '.2px',
        borderRadius: '50%',
        color: theme.palette.cms?.mobileMenuTextColor || theme.palette.mobileMenuColor,
        cursor: 'pointer',
        textDecoration: 'none',
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontWeight: 'normal',
        '& img': {
            width: '24px',
            height: '24px',
        },
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: 'rgba(0, 0, 0, 0.08)',
        },
    },
    flowersQty: {},
    qtyCommon: {
        width: '15px',
        color: '#fff',
        height: '15px',
        display: 'flex',
        position: 'absolute',
        boxSizing: 'content-box',
        fontWeight: '500',
        alignItems: 'center',
        borderRadius: '50%',
        pointerEvents: 'none',
        '@media screen and (max-width: 1024px)': {
            height: '18px',
            width: '18px',
            fontSize: '9px !important',
        },
    },
    qtyItem: {
        top: '1px',
        right: '8px',
        border: '1px solid #fff',
        fontSize: '12px',
        justifyContent: 'center',
        backgroundColor: '#185357',
        '&$flowersQty': {
            top: '12px',
            right: '5px',
        },
    },
    qtyItemFood: {
        top: '25px',
        right: '5px',
    },

    gatheringFlowerCartMobile: {
        gridColumn: 6,
    },
    container: {
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'center',
        alignItems: 'center',
        justifyContent: 'center',
    },
    cartText: {
        lineHeight: '12px',
        color: theme.palette.cms?.mobileMenuTextColor || theme.palette.mobileMenuColor,
        marginTop: '3px',
        fontFamily: 'var(--comp-base-font-family-default, Lato , Helvetica, Arial, sans-serif)',
        fontWeight: 500,
    },
});

const setItemCountCookie = (cookieValue, domain) => {
    const cookies = new Cookies();
    cookies.set('itemCount', cookieValue, {
        path: '/',
        encode: String,
        domain: `.${domain}.com`,
    });
};

const Cart = ({
    orderId, image, classes, orderStatus,
    trackEvent, brand, type, presentationFamily,
    description, cartCount, isGatheringsPage,
}) => {
    const itemCount = !cartStatusCompleteList.includes(orderStatus) ? cartCount : 0;
    const orderID = itemCount !== 0 ? orderId : '';
    const domainName =  brand?.domain || '';
    const isKeeper = useIsKeeper();
    const featureFlags = useSelector(getFeatureFlags);
    const pageType = useSelector(getPageType);
    const mobileIconsWithoutTextEnabled = featureFlags['is-mobile-icons-without-text'];

    const cartIconLabel = featureFlags['cart-icon-label']?.label || 'Cart';
    if (image?.includes('cart.svg') || image?.includes('cart-empty.svg') || image?.includes('cartEmpty.svg')) {
        /* eslint-disable no-param-reassign */
        image = 'https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blt7888ec93d3d5c1ec/5e17829300c38f0f022d3646/Header-Icon-PWA-bag.svg';
    }
    if (itemCount !== 0) {
        setItemCountCookie(itemCount, domainName);
    }

    if (type === 'mobile') {
        return (
            <Link
                to={`/checkout/cart/${orderID}`}
                aria-hidden="true"
                tabIndex="-1"
                className={`${classes.cartMobile} ${presentationFamily === 'flower' && classes.flowerCartMobile} ${(isGatheringsPage || isKeeper) ? classes.gatheringFlowerCartMobile : ''}`}
                onClick={() => {
                    trackEvent({
                        eventCategory: pageType,
                        eventAction: `${cartIconLabel} click`,
                        eventLabel: 'header',
                        feature_detail: 'header',
                        feature_element: `${cartIconLabel} click`,
                        feature_category: pageType,
                    });
                }}
                alt="icon cart mobile" // beware => icon-cart-mobile
                aria-label="Cart-icon"
            >
                <span className={classes.container}>
                    {image && <img src={image} className={`${presentationFamily === 'flower' && classes.flowersCartIcon}`} alt={description} aria-hidden="true" width="24" height="24" />}

                    {!mobileIconsWithoutTextEnabled && (
                        <span className={classes.cartText}>
                            {featureFlags['cart-icon-label']?.label || description}
                        </span>
                    )}
                    {itemCount > 0 && <span className={presentationFamily === 'flower' ? `${classes.qtyCommon} ${classes.qtyItem} ${classes.flowersQty}` : `${classes.qtyCommon} ${classes.qtyItem} ${classes.qtyItemFood}`}>{itemCount}</span> }
                </span>
            </Link>
        );
    }

    return (
        <Link
            to={`/checkout/cart/${orderID}`}
            id="hp-cart"
            data-test="hp-cart-icon"
            name="cartIcon"
            aria-hidden="true"
            tabIndex="-1"
            onClick={() => {
                let origin = '';
                if (typeof window !== 'undefined' && window.location && window.location.origin) {
                    origin = window.location.origin;
                }
                trackEvent({
                    eventCategory: 'Header',
                    eventAction: 'Cart',
                    eventLabel: '<<pageType>>',
                    link_text: 'Cart',
                    header_section: 'Core Browsing Header',
                    link_url: `${origin}/checkout/cart/${orderID}`,
                });
            }}
            alt="cart-icon"
            aria-label="Cart-icon"
        >
            <img src={`${image}?height=25&width=44`} alt="Cart Icon" aria-hidden="true" role="presentation" width="24" height="24" />
            <span
                className={classes.cartTextStyle}
                style={itemCount ? { color: '#a00' } : { color: '#000' }}
            >
                ({itemCount}){' '}{cartIconLabel}
            </span>
            {' '}
            {/* In production, item count comes from a cookie */}
        </Link>
    );
};

Cart.propTypes = {
    cartCount: number,
    orderId: string,
    image: string.isRequired,
    classes: object.isRequired,
    orderStatus: string,
    trackEvent: func.isRequired,
    brand: shape({
        domain: string,
    }),
    type: string,
    description: string,
    presentationFamily: string,
    isGatheringsPage: bool,
};

Cart.defaultProps = {
    cartCount: 0,
    orderId: '',
    orderStatus: '',
    brand: {},
    type: 'desktop',
    description: '',
    presentationFamily: null,
    isGatheringsPage: false,
};

const mapDispatcherToProps = (dispatch) => ({
    trackEvent: bindActionCreators(tagManagerActions.trackEvent, dispatch),
});

const mapStateToProps = (state) => ({
    cartCount: commonSelectors.getTotalItemInCart(state),
    orderId: commonSelectors.getOrderId(state),
    orderStatus: commonSelectors.getOrderStatus(state),
    brand: getBrand(state),
    presentationFamily: getPresentationFamily(state),
});

export default compose(
    withStyles(styles),
    connect(mapStateToProps, mapDispatcherToProps),
)(Cart);
